import React, { Component } from 'react';
import { Formik } from 'formik';
import AsyncSelect from 'react-select/async';
import { toast } from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader';
import debounce from 'lodash/debounce';
import { Container, Card, Button, ButtonGroup, Badge } from 'react-bootstrap';
import {
  FaHashtag,
  FaIdCard,
  FaUserCircle,
  FaUserCheck,
  FaCheckCircle,
  FaSearch,
} from 'react-icons/fa';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';

import * as api from '~/Services/Service';
import EscalaSatisfacao from '~/Components/EscalaSatisfacao/EscalaSatisfacao';

const TIPO_BUSCA = [
  { codigo: 1, label: 'Senha', icon: FaHashtag },
  { codigo: 2, label: 'Código', icon: FaIdCard },
  { codigo: 3, label: 'CPF', icon: FaUserCircle },
];

var getNivelLabel = (atendimentoPreferencial) => {
  if (atendimentoPreferencial === true) return { texto: 'Diamante', cor: '#1565C0', bg: '#E3F2FD' };
  if (atendimentoPreferencial === false) return { texto: 'Topázio', cor: '#E65100', bg: '#FFF3E0' };
  return { texto: 'Sem nível', cor: '#616161', bg: '#F5F5F5' };
};

var formatOptionLabel = (option) => {
  var nivel = getNivelLabel(option.atendimentoPreferencial);
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <span>{option.label}</span>
      <span style={{
        backgroundColor: nivel.bg,
        color: nivel.cor,
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '0.75rem',
        fontWeight: 700,
        marginLeft: '8px',
      }}>
        {nivel.texto}
      </span>
    </div>
  );
};

export default class LancamentoAvaliacao extends Component {
  state = {
    tipoBusca: 1,
    cliente: null,
    codigoAtendimento: '',
    isSubmitting: false,
    initialValues: {
      avaliacao_atendente: '',
      avaliacao_corretor: '',
      motivo_nao_compra: '',
      codigo: '',
    },
  };

  alteraTipo = tipoBusca => {
    this.buscaClienteDebounced.cancel();
    this.setState({
      tipoBusca,
    });
  };

    buscaClienteDebounced = debounce((tipoBusca, value, callback) => {
    api.getProspectoAtendimento(tipoBusca, value).then(
      data => {
        var options = [];
        if (data) {
          options.push({
            value: data.codigo,
            label: data.prospecto.nome,
            data: data,
            atendimentoPreferencial: data.atendimento_preferencial,
          });
          
          let initialValues = {
            avaliacao_atendente: '',
            avaliacao_corretor: '',
            motivo_nao_compra: '',
            codigo: data.codigo,
          };
          if (data.avaliacao) {
            initialValues = {
              avaliacao_atendente: data.avaliacao.avaliacao_atendente,
              avaliacao_corretor: data.avaliacao.avaliacao_corretor,
              motivo_nao_compra: data.avaliacao.motivo_nao_compra || '',
              codigo: data.avaliacao.codigo,
            };
          }
          
          this.setState({ initialValues });
        }
        callback(options);
      },
      error => {
        callback([]);
      }
    );
  }, 350);

  buscaCliente = (value, callback) => {
    if (!value) {
      this.buscaClienteDebounced.cancel();
      callback([]);
      return;
    }
    this.buscaClienteDebounced(this.state.tipoBusca, value, callback);
  };

    salvarPesquisa = async (
    {
      avaliacao_atendente,
      avaliacao_corretor,
      motivo_nao_compra,
      codigo,
    },
    actions
  ) => {
    const pesquisa = {
      codigo_atendimento: this.state.codigoAtendimento,
      avaliacao_atendente,
      avaliacao_corretor,
      motivo_nao_compra,
      codigo,
    };
    try {
      actions.setSubmitting(true);
      await api.salvarPesquisaAtendimento(pesquisa);
      toast.success('Pesquisa salva com sucesso');
    } catch (error) {
      toast.error('Erro ao salvar a pesquisa. Tente novamente');
    } finally {
      this.setState({ cliente: null, codigoAtendimento: '' });
      actions.setSubmitting(false);
      actions.resetForm();
    }
  };

    finalizarSemAvaliacao = async actions => {
    try {
      actions.setSubmitting(true);
      await api.finalizarFluxoAtendimentoLancamento(this.state.codigoAtendimento);
      toast.success('Pesquisa sem avaliação salva com sucesso');
    } catch (error) {
      toast.error('Erro ao salvar a pesquisa Sem avaliação. Tente novamente');
    } finally {
      this.setState({ cliente: null, codigoAtendimento: '' });
      actions.setSubmitting(false);
      actions.resetForm();
    }
  };

    getSelectedOption = () => {
    const { cliente, codigoAtendimento } = this.state;
    if (cliente && cliente.codigo === codigoAtendimento) {
      return {
        value: cliente.codigo,
        label: cliente.prospecto.nome,
        data: cliente,
        atendimentoPreferencial: cliente.atendimento_preferencial,
      };
    }
    return null;
  };

    handleSelectCliente = option => {
    this.setState({ 
      cliente: option.data || null, 
      codigoAtendimento: option.value || '' 
    });
  };

    render() {
    const { tipoBusca, cliente, codigoAtendimento, isSubmitting } = this.state;
    const tipoAtual = TIPO_BUSCA.find(t => Number(t.codigo) === Number(tipoBusca)) || TIPO_BUSCA[0];
    const nivel = cliente ? getNivelLabel(cliente.atendimento_preferencial) : null;

    return (
      <>
        <Container className="py-3 py-md-4" style={{ maxWidth: '720px' }}>
          <HeaderAzul title="Avaliação do Atendimento" contemPesquisa={false} />
          <Card className="border-0 shadow-sm rounded-lg">
            <Card.Body className="p-3 p-md-4 p-lg-5">
              <div className="text-center mb-4">
                <h4 className="font-weight-bold mb-1">Avaliar Atendimento</h4>
                <p className="text-muted small mb-0">
                  Busque o cliente que finalizou o atendimento e registre a avaliação.
                </p>
              </div>

              <label className="text-muted small font-weight-bold text-uppercase mb-2 d-block">
                Buscar por
              </label>
              <ButtonGroup className="d-flex mb-3 flex-wrap" style={{ gap: '6px' }}>
                {TIPO_BUSCA.map(({ codigo, label, icon: Icon }) => {
                  const ativo = Number(codigo) === Number(tipoBusca);
                  return (
                    <Button
                      key={codigo}
                      variant={ativo ? 'primary' : 'outline-primary'}
                      onClick={() => this.alteraTipo(codigo)}
                      disabled={isSubmitting}
                      aria-label={`Buscar por ${label}`}
                      className="d-flex align-items-center justify-content-center flex-grow-1 py-2"
                      style={{ minWidth: '90px', borderRadius: '8px' }}
                    >
                      <Icon className="mr-2" /> {label}
                    </Button>
                  );
                })}
              </ButtonGroup>

              <AsyncSelect
                placeholder={`Informe ${tipoAtual.label.toLowerCase()} do cliente`}
                noOptionsMessage={() => 'Nenhum cliente encontrado'}
                loadOptions={this.buscaCliente}
                onChange={this.handleSelectCliente}
                value={this.getSelectedOption()}
                isDisabled={isSubmitting}
                formatOptionLabel={formatOptionLabel}
                styles={{
                  control: base => ({
                    ...base,
                    minHeight: '46px',
                    borderRadius: '8px',
                    fontSize: '1rem',
                  }),
                }}
              />

              {!cliente && (
                <div className="text-center text-muted py-4">
                  <FaSearch size={28} className="mb-2" style={{ opacity: 0.4 }} />
                  <div className="small">
                    Busque um cliente para registrar a avaliação.
                  </div>
                </div>
              )}

              {cliente && (
                <>
                  <div
                    className="mt-4 p-3 rounded d-flex align-items-center"
                    style={{ background: '#f1f5fb' }}
                  >
                    <FaUserCheck size={28} className="text-primary mr-3" />
                    <div className="flex-grow-1">
                      <div className="font-weight-bold">{cliente.prospecto.nome}</div>
                      {nivel && (
                        <Badge
                          style={{
                            background: nivel.bg,
                            color: nivel.cor,
                            fontWeight: 700,
                          }}
                        >
                          {nivel.texto}
                        </Badge>
                      )}
                    </div>
                  </div>

                  <Formik
                    initialValues={{
                      avaliacao_atendente: '',
                      avaliacao_corretor: '',
                      motivo_nao_compra: '',
                      codigo: cliente ? cliente.codigo : '',
                    }}
                    enableReinitialize
                    onSubmit={this.salvarPesquisa}
                  >
                    {({
                      values,
                      handleSubmit,
                      setFieldValue,
                      errors,
                      isSubmitting: formIsSubmitting,
                      ...actions
                    }) => (
                      <>
                        <div className="mt-5">
                          <EscalaSatisfacao
                            disabled={formIsSubmitting || isSubmitting}
                            onChange={resposta =>
                              setFieldValue('avaliacao_atendente', resposta)
                            }
                            value={values.avaliacao_atendente}
                            error={errors && errors.avaliacao_atendente}
                            label={`Como avalia o atendimento do(a) <strong>${cliente.atendente.nome}</strong>?`}
                          />
                          <EscalaSatisfacao
                            disabled={formIsSubmitting || isSubmitting}
                            onChange={resposta =>
                              setFieldValue('avaliacao_corretor', resposta)
                            }
                            value={values.avaliacao_corretor}
                            error={errors && errors.avaliacao_corretor}
                            label={`Como avalia o atendimento do(a) corretor(a) <strong>${cliente.corretor.nome}</strong>?`}
                          />
                          <div className="form-group mt-4">
                            <label htmlFor="motivo_nao_compra">
                              O que pesou na sua decisão de não comprar?
                              Queremos usar sua opinião para evoluir.
                            </label>
                            <textarea
                              id="motivo_nao_compra"
                              name="motivo_nao_compra"
                              className="form-control"
                              rows={3}
                              value={values.motivo_nao_compra}
                              onChange={e =>
                                setFieldValue(
                                  'motivo_nao_compra',
                                  e.target.value
                                )
                              }
                              disabled={formIsSubmitting || isSubmitting}
                            />
                          </div>
                        </div>
                        <div className="d-flex justify-content-center mt-4">
                          <Button
                            variant="success"
                            size="lg"
                            block
                            className="d-flex align-items-center justify-content-center font-weight-bold me-3"
                            onClick={handleSubmit}
                            disabled={formIsSubmitting || isSubmitting}
                            style={{ borderRadius: '8px' }}
                          >
                            {formIsSubmitting ? (
                              <ClipLoader size={20} color={'#fff'} />
                            ) : (
                              <FaCheckCircle className="mr-2" />
                            )}
                            <span className="ml-2">
                              {formIsSubmitting ? 'Salvando...' : 'Salvar'}
                            </span>
                          </Button>
                          {values.avaliacao_corretor === '' &&
                            values.avaliacao_atendente === '' && (
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                className="d-flex align-items-center justify-content-center font-weight-bold ml-2"
                                onClick={() =>
                                  this.finalizarSemAvaliacao(actions)
                                }
                                disabled={formIsSubmitting || isSubmitting}
                                style={{ borderRadius: '8px' }}
                              >
                                Finalizar sem avaliação
                              </Button>
                            )}
                        </div>
                      </>
                    )}
                  </Formik>
                </>
              )}
            </Card.Body>
          </Card>
        </Container>
      </>
    );
  }
}
